import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class InitiativesFormsGeneralDetailsComponent extends Component {
  @service('organisation') orgService;
  @service intl;
  @service('beta-toggle') betaService;
  @service store;
  initiativeValidations = this.initiativeValidations;

  @action
  handleSourceSelect(changeset, e) {
    changeset.set('source', e.value);
  }

  get sourceOptions() {
    const sourceOptions = this.betaService.sourceOptions;
    sourceOptions.push({ label: 'None', value: undefined });
    return sourceOptions;
  }

  @action
  handleStatusSelect(changeset, e) {
    changeset.set('status', e.value);
  }

  @action
  setDelta(changeset, e) {
    changeset.set('summary', e);
  }

  @action
  handleBlur(changeset) {
    //if page is not navigating away
    if (changeset.get('isPristine') === true) {
      this.isDisabled = true;
    } else if (changeset.get('isValid') === true) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  get themesList() {
    const themes = this.store.peekAll('theme').map((item) => ({
      value: item.id,
      label: item.title,
      color: item.color,
    }));

    return themes;
  }

  @action
  initiativeGoalsIds(changeset) {
    const goals = changeset.get('goals');
    if (goals.isDestroying || goals.isDestroyed) return [];
    const isPromise = 'promise' in goals;
    if (isPromise && !goals?.content) return [];
    if (isPromise && goals?.content)
      return goals?.content.map((team) => team.id);
    return goals.map((item) => item.id) ?? [];
  }

  @action
  hasMoreThanOneGoal(changeset) {
    const goals = changeset.get('goals');
    if (goals.isDestroying || goals.isDestroyed) return [];
    return goals.length > 1 ? goals.length - 1 : false;
  }

  @action
  handleSelect(changeset, field, model, e) {
    let record = null;
    if (Array.isArray(e)) {
      record = e.map((id) => this.store.peekRecord(model, id));
    } else record = this.store.peekRecord(model, e.value);
    changeset.set(field, record);
  }

  @action
  handleGoalsSelect(changeset, e) {
    console.debug(changeset.get('goals'), e);
  }

  @action
  clearSelect(changeset, field) {
    changeset.set(field, null);
  }

  get goalsList() {
    return this.store
      .peekAll('goal')
      .map((goal) => ({ value: goal.id, label: goal.title }));
  }

  @action
  firstGoal(changeset) {
    const goals = changeset.get('goals');
    if ('promise' in goals) return goals?.content?.[0];
    return goals[0];
  }
}
